import { FC, ReactElement, useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ReactComponent as FolderIcon } from '../../assets/icons/folder2.svg'
import { ReactComponent as PatientsIcon } from '../../assets/icons/patients.svg'
import { RoutesEnum } from '../../utils/routesEnum'
import TabItems from '../loggedArea/tabItems'
import { Container } from '../subscription/style'
import PatientList from './list'
import SavePatient from './save'
import PatientView from './view'

type PatientsProps = {
  type: 'list' | 'create' | 'view' | 'edit'
}

const Patients: FC<PatientsProps> = ({ type }): ReactElement => {
  const history = useHistory()
  const [navigationComponent, setNavigationComponent] = useState<ReactElement | undefined>(undefined)

  const activeItem = useCallback(() => {
    if (history.location.pathname.includes(RoutesEnum.PATIENTS_CREATE)) return 1
    if (history.location.pathname.includes(RoutesEnum.PATIENTS)) return 0

    return 0
  }, [history])

  const onTabChange = useCallback((index: number) => {
    if (index === 1) history.push(RoutesEnum.PATIENTS_CREATE)
    if (index === 0) history.push(RoutesEnum.PATIENTS)
  }, [history])

  useEffect(() => {
    setNavigationComponent(undefined)
  }, [setNavigationComponent])

  return (
    <TabItems
      breadcrumbs={[
        { title: 'Pacientes', to: RoutesEnum.PATIENTS },
        { title: 'Meus pacientes', to: RoutesEnum.PATIENTS },
        ...(activeItem() === 1 ? [{ title: 'Inserir paciente', to: RoutesEnum.PATIENTS_CREATE }] : [])
      ]}
      navigationComponent={navigationComponent}
      items={[
        { name: 'Meus pacientes', icon: <PatientsIcon /> },
        { name: 'Inserir paciente', icon: <FolderIcon /> }
      ]}
      activeItem={activeItem()}
      onChangeTab={onTabChange}
      title='Pacientes'
      subtitle={`Aqui você consegue ver o histórico completo
      de seus pacientes inserir e alterar o cadastro.`}
    >
      <Container>
        {type === 'create' && <SavePatient />}
        {type === 'list' && <PatientList />}
        {type === 'view' && <PatientView setNavigationComponent={setNavigationComponent} />}
        {type === 'edit' && <SavePatient />}
      </Container>
    </TabItems>
  )
}

export default Patients
